import React from 'react'
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import TeacherCardModal from './TeacherCardModal';
import Axios from 'axios';
import { getAuthHeader } from '../../utils/authToken';

const TooltipContent = ({ events, expanded, onExpand }) => {
    if (!events || events.length === 0) return null;

    const formatEvent = (e) => `${e.title} (${e.date})`;

    if (events.length <= 6 || expanded) {
        return <>{events.map(formatEvent).join('\n')}</>;
    }

    const first3 = events.slice(0, 3);
    const last3 = events.slice(-3);

    return (
        <>
            {first3.map(formatEvent).join('\n')}
            {'\n...\n'}
            {last3.map(formatEvent).join('\n')}
            {'\n'}
            <span
                onClick={(e) => { e.stopPropagation(); onExpand(); }}
                style={{ color: '#90caf9', cursor: 'pointer', textDecoration: 'underline' }}
            >
                See more ({events.length - 6} hidden)
            </span>
        </>
    );
};

const TeacherChip = ({ teacher, is_current = true, taught_events = [], setInfoUpdated }) => {
    const [openModal, setModalOpen] = React.useState(false);
    const [teacherInfo, setTeacherInfo] = React.useState(null);
    const [expanded, setExpanded] = React.useState(false);

    const handleModalOpen = async () => {
        Axios.get(`${process.env.REACT_APP_URL}/api/v1/teachers/${teacher.uuid}`, {
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then(res => {
            setTeacherInfo(res.data);
            setModalOpen(true);
        }).catch(err => {
            console.log(err);
        })
    };

    return (<>
        <Tooltip
            title={<TooltipContent events={taught_events} expanded={expanded} onExpand={() => setExpanded(true)} />}
            arrow
            placement="bottom"
            onClose={() => setExpanded(false)}
            componentsProps={{
                tooltip: {
                    sx: {
                        whiteSpace: 'pre-line',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        fontSize: '16px',
                    }
                }
            }}
        >
            <span>
                <Chip
                    label={is_current
                        ? teacher.first_name + " " + teacher.last_name.substring(0, 1) + "."
                        : <s>{teacher.first_name + " " + teacher.last_name.substring(0, 1) + "."}</s>
                    }
                    onClick={handleModalOpen}
                    sx={{
                        m: 1,
                        opacity: is_current ? 1 : 0.4,
                    }}
                />
            </span>
        </Tooltip>
        <TeacherCardModal openModal={openModal} setModalOpen={setModalOpen} teacher={teacherInfo} setInfoUpdated={setInfoUpdated} />
    </>)
}

export default TeacherChip
